import React from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';

const Navbar = () => {
    const carts = useSelector(state => state.carts)
    const cartsLen = carts.reduce((pre, current) => pre + current.quantity, 0)
    return (
        <nav className="bg-[#171C2A] py-4">
            <div className="navBar">
                <NavLink to='/' >
                    <img src="./images/logo.png" alt="LWS" className="max-w-[140px]" />
                </NavLink>

                <div className="flex gap-4">
                    <NavLink to="/" className="navHome" id="lws-home"> Home </NavLink>
                    <NavLink to="/checkout" className="navCart" id="lws-cart">
                        <i className="text-xl fa-sharp fa-solid fa-bag-shopping"></i>
                        <span id="lws-totalCart">{cartsLen}</span>
                    </NavLink>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;